import React from 'react';
import { useParams } from 'react-router-dom';

import OrganisationProfile from '@components/OrganisationProfile';

import { useMutateBlockUnblockOrganisation } from '@hooks/organisation/useMutateBlockUnblockOrganisation';
import { useMutateEditOrganisationProfile } from '@hooks/organisation/useMutateEditOrganisationProfile';
import { useQueryOrganisationProfileById } from '@hooks/organisation/useQueryOrganisationProfile';

import { IOrganisationProfile } from '@interfaces/organisation/organisations';

const OrganisationProfileHoc = () => {
	const { id = '' } = useParams();

	const { profile, isLoadingProfile } = useQueryOrganisationProfileById(id);
	const { handleChangeStatusOrganisation, isUpdatingOrganisationStatus } = useMutateBlockUnblockOrganisation();
	const { handleUpdateOrganisation, isLoadingUpdateOrganisation } = useMutateEditOrganisationProfile(id);

	return (
		<OrganisationProfile
			handleChangeStatusOrganisation={handleChangeStatusOrganisation}
			handleUpdateOrganisation={handleUpdateOrganisation}
			isLoadingProfile={isLoadingProfile}
			isLoadingUpdateOrganisation={isLoadingUpdateOrganisation || isUpdatingOrganisationStatus}
			organisationId={id}
			profile={profile as IOrganisationProfile}
		/>
	);
};

export default OrganisationProfileHoc;
